import { FeApi } from '@/api/fe-api';
import {
  type UnitOverviewColumnConfig,
  type UnitOverviewRow,
} from '@/warranty-v3/entities/overview';

export function unitOverviewColumnMapper(
  data: FeApi.UnitOverviewColumnConfig,
): UnitOverviewColumnConfig {
  return {
    column: data.column,
    order: data.order,
    title: data.title ?? undefined,
    tooltip: data.tooltip ?? undefined,
  };
}

export function unitOverviewRowMapper(
  data: FeApi.UnitOverviewRow,
): UnitOverviewRow {
  return {
    id: data.id,
    frontendId: data.frontend_id ?? undefined,
    coverageStatus: data.coverage_status ?? undefined,
    complianceStatus: data.compliance_status ?? undefined,
    suggestedAction: data.suggested_action ?? undefined,
    ageInYears: data.age_in_years ?? undefined,
    cyclesTotal: data.cycles_total ?? undefined,
    throughputTotal: data.throughput_total ?? undefined,
    guaranteedSOH: data.guaranteed_soh
      ? {
          base: data.guaranteed_soh.base,
          penalty: data.guaranteed_soh.penalty,
          effective: data.guaranteed_soh.effective,
        }
      : undefined,
    soh: data.soh ?? undefined,
    avgContainerTag: data.avg_container_tag ?? undefined,
    avgPcsTag: data.avg_pcs_tag ?? undefined,
  };
}

export function unitOverviewMapper(data: FeApi.UnitOverview | undefined): {
  columns: UnitOverviewColumnConfig[];
  rows: UnitOverviewRow[];
} {
  return {
    columns: data?.columns.map(unitOverviewColumnMapper) ?? [],
    rows: data?.rows.map(unitOverviewRowMapper) ?? [],
  };
}
